import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	ZarizeniId: null as number | null,
	ZarizenikatId: null as number | null,
	ProvozovnaId: null as number | null,
	ZarizeniNr: null as string | null,
	Text: null as string | null,
	StavPzn: null as number | null,
	PouzitelPzn: null as number | null,
	CmrozvrhId: null as number | null,
	Priorita: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		ZarizenikatId: [],
		StavPzn: [],
		PouzitelPzn: [],
		CmRozvrhId: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
